import { INhomLopCopyDuLieuTuKyTruocRequest } from "../../../model/request/category/INhomLopCopyDuLieuTuKyTruocRequest";
import { INhomLopGhepCapTuDongRequest } from "../../../model/request/category/INhomLopGhepCapTuDongRequest";
import { IStuNhomLopCreateFromCtdtRequest } from "../../../model/request/category/IStuNhomLopCreateFromCtdtRequest";
import { IStuNhomLopCreateAutoRequest } from "../../../model/request/category/IStuNhomLopCreateAutoRequest";
import { IStuNhomLopInsertRequest } from "../../../model/request/category/IStuNhomLopInsertRequest";
import { IStuNhomLopUpdateCaHocRequest } from "../../../model/request/category/IStuNhomLopUpdateCaHocRequest";
import { IIdsRequest } from "../../../model/request/IIdsRequest";
import { IStuNhomLop } from "../../../model/respone/category/IStuNhomLop";
import { IStuNhomLopViewModel } from "../../../model/respone/category/IStuNhomLopViewModel";
import { IStuNhomLopPhanLopTuDong, IStuNhomLopReducerFilter } from "../../reducer-model/category/IStuNhomLopReducer";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eStuNhomLopActionsObj = {
  LOAD_START: {} as { nam_hoc: string, hoc_ky: number },
  LOAD_SUCCESS: {} as IStuNhomLopViewModel[],
  LOAD_ERRR: "",
  CHANGE_SELECTED_IDS: {} as number[],
  SHOW_PHAN_NHOM_TU_DONG_MODAL: {} as boolean,
  CHANGE_FILTER: {} as IStuNhomLopReducerFilter,
  UPDATE_PHAN_NHOM_TU_DONG_DATA: {} as IStuNhomLopPhanLopTuDong,
  PREVIEW_PHAN_NHOM_TU_DONG_START: {} as IStuNhomLopCreateAutoRequest,
  PREVIEW_PHAN_NHOM_TU_DONG_SUCCESS: {} as IStuNhomLopViewModel[],
  PREVIEW_PHAN_NHOM_TU_DONG_ERROR: "",
  DELETE_START: {} as IIdsRequest,
  DELETE_SUCCESS: undefined,
  DELETE_ERROR: "",
  SAVE_PHAN_NHOM_TU_DONG_START: {} as IStuNhomLopCreateAutoRequest,
  SAVE_PHAN_NHOM_TU_DONG_SUCCESS: {} as IStuNhomLopViewModel[],
  SAVE_PHAN_NHOM_TU_DONG_ERROR: "",
  SHOW_EIDT_MODAL: {} as IStuNhomLopViewModel | undefined,
  CLOSE_EIDT_MODAL: undefined,
  UPDATE_CA_HOC_START: {} as IStuNhomLopUpdateCaHocRequest,
  UPDATE_CA_HOC_SUCCESS: {} as IStuNhomLop[],
  UPDATE_CA_HOC_ERROR: "",

  UPDATE_START: {} as IStuNhomLop & { id_lops?: number[] },
  UPDATE_SUCCESS: {} as IStuNhomLop,
  UPDATE_ERROR: "",

  INSERT_START: {} as IStuNhomLopInsertRequest,
  INSERT_SUCCESS: {} as IStuNhomLopViewModel,
  INSERT_ERROR: "",

  COPY_NHON_LOP_TU_KY_TRUOC_START: {} as INhomLopCopyDuLieuTuKyTruocRequest,
  COPY_NHON_LOP_TU_KY_TRUOC_SUCCESS:  undefined,
  COPY_NHON_LOP_TU_KY_TRUOC_ERROR: "",

  GHEP_CAP_TU_DONG_START: {} as INhomLopGhepCapTuDongRequest,
  GHEP_CAP_TU_DONG_SUCCESS: undefined,
  GHEP_CAP_TU_DONG_ERROR: "",

  CREATE_FROM_CTDT_START: {} as IStuNhomLopCreateFromCtdtRequest,
  CREATE_FROM_CTDT_SUCCESS: undefined,
  CREATE_FROM_CTDT_ERROR: "",
};
export const eStuNhomLopActionIds = generateActionTypeIds(
  eStuNhomLopActionsObj,
  "NHOM_LOP"
);
export type IStuNhomLopActionTypes = IGenericActionType<
  typeof eStuNhomLopActionsObj,
  "NHOM_LOP"
>;
